import { createActionGroup, emptyProps, props } from '@ngrx/store';

export const applicationsDetailsActions = createActionGroup({
  source: 'Einreichung - Applications details',
  events: {
    'Delete document by id': props<{ id: string }>(),
    'Load': props<{ applicationId: string | null }>(),
    'Load success': props<{ application: any }>(),
    'Load failed': props<{ error: any }>(),
    'Clear store': emptyProps(),
  },
});
